var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"8":1,"389":1,"528":1,"546":1,"623":1,"631":1,"832":1,"909":1,"1036":1,"1060":1,"1078":1,"1088":1,"1150":1,"1188":1,"1284":1,"1400":1,"1503":1,"1522":1,"1549":1,"1589":1,"1637":1,"1652":1,"1874":1,"1876":1,"2014":1,"2042":1,"2059":1,"2061":1,"2140":1,"2195":1,"2335":1,"2405":1,"2420":1,"2513":1,"2516":1,"2634":1,"2684":1,"2714":1,"2740":1,"2821":1,"2844":1,"2869":1,"2896":1,"2977":1,"3012":1,"3076":1,"3095":1,"3119":1,"3126":1,"3143":1,"3188":1,"3283":1,"3295":1,"3331":1,"3378":1,"3413":1,"3466":1,"3541":1,"3548":1,"3832":1,"3911":1,"4015":1,"4047":1,"4131":1,"4133":1,"4232":1,"4250":1,"4255":1,"4256":1,"4323":1,"4366":1,"4522":1,"4629":1,"4653":1,"4656":1,"4692":1,"4755":1,"4760":1,"4797":1,"4801":1,"4802":1,"4824":1,"4838":1,"4859":1,"4865":1,"4902":1,"4922":1,"4926":1,"4928":1,"5151":1,"5177":1,"5261":1,"5341":1,"5553":1,"5633":1,"5648":1,"5727":1,"5891":1,"5958":1,"6013":1,"6102":1,"6108":1,"6150":1,"6182":1,"6229":1,"6323":1,"6491":1,"6512":1,"6583":1,"6654":1,"6661":1,"6708":1,"6748":1,"6765":1,"6806":1,"6815":1,"6865":1,"6896":1,"6912":1,"6930":1,"6976":1,"6996":1,"7004":1,"7274":1,"7285":1,"7365":1,"7431":1,"7477":1,"7501":1,"7503":1,"7511":1,"7533":1,"7725":1,"7851":1,"7895":1,"7926":1,"7971":1,"7975":1,"8038":1,"8062":1,"8116":1,"8118":1,"8134":1,"8256":1,"8294":1,"8575":1,"8622":1,"8862":1,"8872":1,"9077":1,"9089":1,"9133":1,"9189":1,"9252":1,"9257":1,"9271":1,"9275":1,"9311":1,"9455":1,"9460":1,"9530":1,"9531":1,"9547":1,"9624":1,"9772":1,"9827":1,"9876":1,"9885":1,"9917":1,"9953":1,"9955":1,"9961":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr